import { render } from "./WText.vue?vue&type=template&id=f8ca6b52&scoped=true"
import script from "./WText.vue?vue&type=script&lang=js"
export * from "./WText.vue?vue&type=script&lang=js"

import "./WText.vue?vue&type=style&index=0&id=f8ca6b52&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ca6b52"]])

export default __exports__